var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',_vm._g({attrs:{"height":"24","width":"24","xmlns":"http://www.w3.org/2000/svg"}},_vm.$listeners),[_c('path',{attrs:{"d":"M2.707 6.293a1 1 0 0 0-1.414 1.414l6 6a1 1 0 0 0 1.414 0L13 9.414 19.586 16H16a1 1 0 1 0 0 2h6a1 1 0 0 0 1-1v-6a1 1 0 1 0-2 0v3.586l-7.293-7.293a1 1 0 0 0-1.414 0L8 11.586z","fill-rule":"evenodd"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }